import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-modal-confirm-delete-query',
  templateUrl: './modal-confirm-delete-query.component.html',
  imports: [MatDialogModule, MatButtonModule, TranslocoPipe],
})
export class ModalConfirmDeleteQueryComponent {
  dialogRef = inject(MatDialogRef<ModalConfirmDeleteQueryComponent>);
  data = inject<{ name: string }>(MAT_DIALOG_DATA);
}
